export default {"src":"/_next/static/media/family-cat.b06086e2.svg","height":100,"width":100,"blurWidth":0,"blurHeight":0};